function damp(targetValue, currentValue, factor = 0.5, precision = 0.01) {
  return Math.abs(targetValue - currentValue) < precision ? targetValue : currentValue + (targetValue - currentValue) * factor;
}
export {
  damp
};
//# sourceMappingURL=damp.js.map
